import components from "../../nodes";
import { useContext, useState } from "react";
import UIContext from "../../store/UIContext";
import Tippy from "@tippyjs/react";
import styles from "./style.module.css";
import "tippy.js/dist/tippy.css";
import { useSyncedStore } from "@syncedstore/react";
import store from "../../store";
import cn from "classnames";

export default function Toolbar() {
  const state = useSyncedStore(store);

  const { methods: UIMethods } = useContext(UIContext);

  const [selectedTab, setSelectedTab] = useState("Input");

  function copy() {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(JSON.stringify(state));
    }
  }

  const groups = components.reduce((acc, comp) => {
    return acc.find((name) => comp.group === name)
      ? acc
      : comp.group
      ? [...acc, comp.group]
      : acc;
  }, []);

  const comps = components.filter((comp) => comp.group === selectedTab);

  return (
    <div className={styles.toolbar}>
      <div className={styles.tabsContainer}>
        {groups.map((group, i) => {
          return (
            <button
              className={cn({
                [styles.tabButton]: true,
                [styles.tabButtonSelected]: group === selectedTab,
              })}
              key={i}
              onClick={() => setSelectedTab(group)}
            >
              {group}
            </button>
          );
        })}
      </div>
      <div className={styles.componentsContainer}>
        {comps.map((component, cI) => {
          return (
            <Tippy key={cI} placement="bottom" content={component.name}>
              <button
                className={styles.toolbarButton}
                onClick={() => UIMethods.addNode(component.name)}
              >
                {component.icon && component.icon()}
              </button>
            </Tippy>
          );
        })}
      </div>
    </div>
  );
}
